var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.061,
    height: 13.942,
    viewBox: "0 0 55.061 13.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4344",
    "data-name": "Group 4344",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3062",
    "data-name": "Path 3062",
    d: "M819.166,85.7l2.6,5.17-5.465,5.17Z",
    transform: "translate(-766.704 -85.681)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3063",
    "data-name": "Path 3063",
    d: "M780.071,85.7l2.6,5.17-5.469,5.17Z",
    transform: "translate(-729.434 -85.681)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4258",
    "data-name": "Group 4258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3064",
    "data-name": "Path 3064",
    d: "M-349.049,777.673a.8.8,0,0,0,.1.016q5.528,0,11.055,0a1.358,1.358,0,0,0,1.4-1.09c.362-1.308.706-2.621,1.089-3.923a.768.768,0,0,0-.816-1.066c-2.929.025-5.858.01-8.788.011h-.359c.182-.658.369-1.261.511-1.874.066-.284.2-.343.465-.342q4.762.013,9.525.006a.861.861,0,0,0,.225-.006c.06-.017.144-.062.159-.112.177-.6.343-1.21.518-1.839-.115-.006-.2-.014-.279-.014q-5.414,0-10.829,0a1.4,1.4,0,0,0-1.451,1.107q-.551,1.975-1.094,3.951-.3,1.087.834,1.086h9.1c-.029.124-.046.213-.07.3-.135.491-.291.976-.4,1.473-.062.281-.172.368-.467.367-3.2-.012-6.406-.005-9.61-.013a.31.31,0,0,0-.361.278C-348.731,776.543-348.89,777.095-349.049,777.673Z",
    transform: "translate(382.798 -767.436)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M-849.449,777.807l5.342-4.882.057.028-1.328,4.838c.594,0,1.168-.01,1.741.006.214.006.286-.074.339-.269q1.153-4.2,2.321-8.391c.136-.491.268-.982.421-1.544l-8.512,7.192-4.371-7.239-2.835,10.245c.6,0,1.178-.01,1.753.005a.278.278,0,0,0,.327-.249q.679-2.5,1.373-4.989c.026-.093.06-.183.108-.328Z",
    transform: "translate(861.264 -767.541)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M-594.4,777.682c.617,0,1.193-.009,1.768.005a.256.256,0,0,0,.307-.228c.32-1.192.662-2.378.975-3.572.066-.251.167-.317.419-.316q4.393.015,8.786.006a1.379,1.379,0,0,0,1.415-1.069c.028-.1.057-.2.085-.3q.51-1.839,1.02-3.678c.2-.713-.094-1.1-.833-1.1h-10.628c-.469,0-.472,0-.6.44-.141.5-.276,1-.424,1.545H-581.9c-.022.1-.033.174-.052.244-.15.545-.321,1.085-.444,1.636-.058.261-.17.318-.419.318q-4.761-.01-9.523,0h-.376Z",
    transform: "translate(614.238 -767.432)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M-923.236,767.824c-.61,0-1.166.011-1.721-.005-.221-.007-.306.066-.364.279q-1.027,3.76-2.073,7.515c-.223.8-.447,1.608-.674,2.425h2.006Z",
    transform: "translate(928.987 -767.796)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M-455.979,977.342l-.979,1.937.064.072c.1-.077.232-.133.289-.234.166-.29.3-.6.474-.945l.257,1.2.911-1.183-.051,1.1h.272l.088-1.955-1.052,1.426Z",
    transform: "translate(484.589 -965.438)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M-919.548,977.482l-.05-.016-1,1.355-.272-1.422-.978,1.935c.2.079.29,0,.364-.164.137-.3.292-.6.465-.949l.252,1.213.914-1.19c-.019.385-.036.736-.054,1.1h.269C-919.608,978.718-919.578,978.1-919.548,977.482Z",
    transform: "translate(923.121 -965.494)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    "data-name": "Path 3070",
    d: "M-865.985,978.732l-.27-1.431-.979,1.943.071.074c.1-.08.222-.142.28-.244.167-.291.306-.6.476-.937l.252,1.2.918-1.184c-.026.417-.046.754-.067,1.1h.279l.09-1.948Z",
    transform: "translate(871.603 -965.402)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    d: "M-363.423,977.29l-.541,1.945c.19.063.284.024.33-.179.08-.356.2-.7.3-1.08l1.037,1.358.542-1.953h-.275l-.36,1.277Z",
    transform: "translate(396.868 -965.391)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    d: "M-70.3,978.278c.113-.3.057-.39-.257-.445a1.347,1.347,0,0,0-1.434.826.807.807,0,0,0,.067.905.859.859,0,0,0,.889.212c.25-.05.446-.144.428-.432a3.521,3.521,0,0,1-.5.176.513.513,0,0,1-.624-.694A.913.913,0,0,1-70.3,978.278Z",
    transform: "translate(121.544 -965.887)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    d: "M-250.366,978.3a.469.469,0,0,0-.583-.356.707.707,0,0,0-.627.529c-.067.3.145.42.349.545.032.02.075.031.1.058.063.085.174.185.161.263a.435.435,0,0,1-.211.268c-.223.118-.392.017-.5-.208l-.223.109c-.006.029-.012.039-.01.047.1.4.573.508.978.214a.539.539,0,0,0-.032-.984,1.3,1.3,0,0,1-.121-.072c-.129-.1-.24-.207-.107-.373a.33.33,0,0,1,.449-.1A1.451,1.451,0,0,0-250.366,978.3Z",
    transform: "translate(291.167 -966.002)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M-622.506,978.9c.768-.07.768-.07.8-.265-.294,0-.586-.007-.877.006a.235.235,0,0,0-.176.126c-.171.576-.329,1.156-.5,1.751h1.049l.074-.271h-.719c.1-.611.1-.611.66-.618a.53.53,0,0,1,.057,0c.17.018.236-.061.219-.255h-.717Z",
    transform: "translate(641.46 -966.658)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M-210.867,980.492h-.709c.113-.615.113-.615.688-.626.019,0,.042.007.056,0,.079-.051.156-.105.234-.158l-.043-.089h-.668c.03-.5.03-.5.478-.5a1.448,1.448,0,0,1,.2,0c.186.026.216-.08.219-.234h-1.037l-.521,1.879c.3,0,.57-.012.841,0C-210.949,980.779-210.867,980.714-210.867,980.492Z",
    transform: "translate(253.494 -966.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M-400.763,980.24c.078-.617.078-.617.653-.621.028,0,.063.01.084,0,.082-.05.159-.107.238-.161l-.041-.09h-.72l.146-.5h.5c.255,0,.255,0,.276-.245-.284,0-.567-.009-.849.006a.262.262,0,0,0-.2.134c-.171.575-.326,1.154-.488,1.743h1.05l.073-.268Z",
    transform: "translate(431.959 -966.647)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M-808.415,980.285h-.715l.177-.617h.506c.257,0,.257,0,.259-.26h-.667c.056-.489.056-.489.5-.489a.547.547,0,0,0,.2,0,1.444,1.444,0,0,0,.235-.153l-.044-.086c-.3,0-.6,0-.9,0a.19.19,0,0,0-.145.1c-.168.586-.325,1.174-.487,1.767a.975.975,0,0,0,.113.017c.245,0,.492-.008.736,0C-808.461,980.578-808.389,980.5-808.415,980.285Z",
    transform: "translate(817.142 -966.697)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M-131.324,978.748l.3,1.953,1.375-1.947c-.449-.084-.486.308-.66.511-.189.22-.34.473-.527.74l-.172-1.257Z",
    transform: "translate(177.418 -966.762)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    d: "M-484.417,979.227c-.247-.769-.247-.769-.571-.69a1.8,1.8,0,0,1,.084,1.831h.37c-.007-.84.628-1.3,1.15-1.888C-483.954,978.489-484.047,979.022-484.417,979.227Z",
    transform: "translate(511.03 -966.514)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M-309.286,978.859l-.445,1.637h.3c.125-.448.263-.888.365-1.335.053-.236.149-.347.395-.3.181.034.253-.054.243-.246-.38,0-.756-.009-1.131.008-.079,0-.155.1-.232.159l.045.079Z",
    transform: "translate(345.771 -966.637)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M-653.856,978.863l-.448,1.63h.3c.122-.444.253-.876.358-1.315.056-.232.144-.371.411-.322.178.033.261-.043.209-.243-.365,0-.733.008-1.1,0-.19-.005-.217.087-.2.253Z",
    transform: "translate(670.771 -966.636)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M-725.258,980.431l.051.076c.091-.05.242-.081.264-.152.177-.58.33-1.168.5-1.78l-.3.018Z",
    transform: "translate(737.677 -966.604)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3083",
    "data-name": "Path 3083",
    d: "M-944.282,980.513l.3-.014.509-1.847c-.209-.08-.3-.019-.352.167C-943.965,979.372-944.12,979.922-944.282,980.513Z",
    transform: "translate(944.282 -966.643)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3084",
    "data-name": "Path 3084",
    d: "M-95.929,980.813h.3l.513-1.86h-.3Z",
    transform: "translate(144.03 -966.96)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3085",
    "data-name": "Path 3085",
    d: "M-349.049,777.673c.159-.578.318-1.13.458-1.686a.31.31,0,0,1,.361-.278c3.2.008,6.407,0,9.61.013.3,0,.406-.086.467-.367.109-.5.265-.982.4-1.473.024-.087.041-.177.07-.3h-9.1q-1.131,0-.834-1.086.544-1.977,1.094-3.951a1.4,1.4,0,0,1,1.451-1.107q5.414,0,10.829,0c.082,0,.164.008.279.014-.175.628-.341,1.235-.518,1.839-.015.05-.1.1-.159.112a.861.861,0,0,1-.225.006q-4.762,0-9.525-.006c-.267,0-.4.058-.465.342-.142.613-.329,1.216-.511,1.874h.359c2.929,0,5.859.014,8.788-.011a.768.768,0,0,1,.816,1.066c-.382,1.3-.726,2.615-1.089,3.923a1.358,1.358,0,0,1-1.4,1.09q-5.528,0-11.055,0A.8.8,0,0,1-349.049,777.673Z",
    transform: "translate(382.798 -767.436)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3086",
    "data-name": "Path 3086",
    d: "M-849.449,777.807l-3.264-5.576c-.048.145-.083.235-.108.328q-.689,2.494-1.373,4.989a.278.278,0,0,1-.327.249c-.575-.015-1.15-.005-1.753-.005l2.835-10.245,4.371,7.239,8.512-7.192c-.153.562-.286,1.054-.421,1.544q-1.162,4.195-2.321,8.391c-.053.195-.126.275-.339.269-.573-.016-1.147-.006-1.741-.006l1.328-4.838-.057-.028Z",
    transform: "translate(861.264 -767.541)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3087",
    "data-name": "Path 3087",
    d: "M-594.4,777.682l1.688-6.069h.376q4.761,0,9.523,0c.249,0,.361-.056.419-.318.123-.551.294-1.091.444-1.636.019-.069.031-.141.052-.244h-10.209c.148-.54.283-1.043.424-1.545.124-.441.128-.44.6-.44h10.628c.74,0,1.031.385.833,1.1q-.509,1.84-1.02,3.678c-.028.1-.057.2-.085.3a1.379,1.379,0,0,1-1.415,1.069q-4.393,0-8.786-.006c-.252,0-.353.065-.419.316-.313,1.194-.655,2.38-.975,3.572a.256.256,0,0,1-.307.228C-593.207,777.674-593.783,777.682-594.4,777.682Z",
    transform: "translate(614.238 -767.432)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3088",
    "data-name": "Path 3088",
    d: "M-923.236,767.824l-2.826,10.213h-2.006c.227-.816.451-1.62.674-2.425q1.04-3.757,2.073-7.515c.058-.213.143-.285.364-.279C-924.4,767.835-923.846,767.824-923.236,767.824Z",
    transform: "translate(928.987 -767.796)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    "data-name": "Path 3089",
    d: "M-455.979,977.342l.273,1.423,1.052-1.426-.088,1.955h-.272l.051-1.1-.911,1.183-.257-1.2c-.172.348-.308.655-.474.945-.058.1-.191.157-.289.234l-.064-.072Z",
    transform: "translate(484.589 -965.438)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    d: "M-919.548,977.482c-.03.618-.061,1.236-.092,1.865h-.269c.018-.366.035-.718.054-1.1l-.914,1.19-.252-1.213c-.173.35-.328.645-.465.949-.074.164-.165.243-.364.164l.978-1.935.272,1.422,1-1.355Z",
    transform: "translate(923.121 -965.494)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    d: "M-865.985,978.732l1.051-1.426-.09,1.948h-.279c.021-.347.042-.684.067-1.1l-.918,1.184-.252-1.2c-.17.339-.309.646-.476.937-.058.1-.185.164-.28.244l-.071-.074.979-1.943Z",
    transform: "translate(871.603 -965.402)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3092",
    "data-name": "Path 3092",
    d: "M-772.454,980.578c.165-.6.317-1.176.485-1.744a.262.262,0,0,1,.2-.139,5.171,5.171,0,0,1,.707.017.558.558,0,0,1,.535.637,1.251,1.251,0,0,1-1.262,1.228C-772,980.582-772.206,980.578-772.454,980.578Zm.383-.3c.833.131,1.093-.269,1.189-.753a.539.539,0,0,0-.137-.466,1.746,1.746,0,0,0-.648-.1c-.021,0-.059.068-.07.109C-771.849,979.47-771.957,979.868-772.071,980.283Z",
    transform: "translate(782.197 -966.712)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3093",
    "data-name": "Path 3093",
    d: "M-363.423,977.29l1.035,1.367.36-1.277h.275l-.542,1.953-1.037-1.358c-.108.376-.223.724-.3,1.08-.046.2-.14.242-.33.179Z",
    transform: "translate(396.868 -965.391)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3094",
    "data-name": "Path 3094",
    d: "M-171.585,980.572c-.617.011-.463-.6-.779-.834l-.238.816h-.275l.52-1.876c.194,0,.382-.01.568,0,.338.021.446.178.369.509a.669.669,0,0,1-.57.52Zm-.736-1.114c.4.033.6-.069.593-.3a.3.3,0,0,0-.185-.218C-172.337,978.879-172.11,979.294-172.321,979.458Z",
    transform: "translate(216.615 -966.696)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    "data-name": "Path 3095",
    d: "M-70.3,978.278a.913.913,0,0,0-1.434.548.513.513,0,0,0,.624.694,3.521,3.521,0,0,0,.5-.176c.018.288-.178.383-.428.432a.859.859,0,0,1-.889-.212.807.807,0,0,1-.067-.905,1.347,1.347,0,0,1,1.434-.826C-70.238,977.888-70.182,977.976-70.3,978.278Z",
    transform: "translate(121.544 -965.887)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    "data-name": "Path 3096",
    d: "M-532.225,979.319l1.439-1.936.368,1.951h-.305l-.1-.484a2.542,2.542,0,0,0-.621.013.735.735,0,0,0-.336.3A.336.336,0,0,1-532.225,979.319Zm1.28-1.334-.428.609h.513Z",
    transform: "translate(555.588 -965.479)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    d: "M-250.366,978.3a1.451,1.451,0,0,1-.377-.06.33.33,0,0,0-.449.1c-.133.166-.022.276.107.373a1.3,1.3,0,0,0,.121.072.539.539,0,0,1,.032.984c-.406.294-.883.19-.978-.214,0-.008,0-.018.01-.047l.223-.109c.1.225.272.326.5.208a.435.435,0,0,0,.211-.268c.013-.077-.1-.178-.161-.263-.021-.028-.064-.039-.1-.058-.2-.125-.416-.246-.349-.545a.707.707,0,0,1,.627-.529A.469.469,0,0,1-250.366,978.3Z",
    transform: "translate(291.167 -966.002)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    d: "M-702.793,977.319l.365,1.948h-.308l-.094-.478a2.874,2.874,0,0,0-.642.013c-.121.029-.231.173-.312.288a.354.354,0,0,1-.453.173Zm-.6,1.223h.521l-.089-.612Z",
    transform: "translate(717.847 -965.419)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    "data-name": "Path 3099",
    d: "M-622.506,978.9l-.129.474h.717c.017.194-.049.273-.219.255a.53.53,0,0,0-.057,0c-.565.007-.565.007-.66.618h.719l-.074.271h-1.049c.166-.594.324-1.174.5-1.751a.235.235,0,0,1,.176-.126c.291-.013.583-.006.877-.006C-621.738,978.83-621.738,978.83-622.506,978.9Z",
    transform: "translate(641.46 -966.658)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    d: "M-210.867,980.492c0,.222-.081.287-.264.276-.271-.016-.544,0-.841,0l.521-1.879h1.037c0,.154-.033.26-.219.234a1.448,1.448,0,0,0-.2,0c-.447,0-.447,0-.478.5h.668l.043.089c-.078.053-.154.107-.234.158-.013.009-.037,0-.056,0-.575.011-.575.011-.688.626h.709Z",
    transform: "translate(253.494 -966.895)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3101",
    "data-name": "Path 3101",
    d: "M-400.763,980.24h.721l-.073.268h-1.05c.163-.589.317-1.169.488-1.743a.262.262,0,0,1,.2-.134c.282-.015.565-.006.849-.006-.021.245-.021.245-.276.245h-.5l-.146.5h.72l.041.09c-.079.054-.156.111-.238.161-.021.013-.056,0-.084,0C-400.685,979.622-400.685,979.622-400.763,980.24Z",
    transform: "translate(431.959 -966.647)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    d: "M-808.415,980.285c.025.218-.047.293-.236.283-.245-.013-.491,0-.736,0a.975.975,0,0,1-.113-.017c.162-.593.319-1.181.487-1.767a.19.19,0,0,1,.145-.1c.3-.009.6,0,.9,0l.044.086a1.444,1.444,0,0,1-.235.153.547.547,0,0,1-.2,0c-.441,0-.441,0-.5.489h.667c0,.259,0,.259-.259.26h-.506l-.177.617Z",
    transform: "translate(817.142 -966.697)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    d: "M-559.471,980.854h-.279c.165-.6.324-1.173.486-1.75.012-.042.043-.113.063-.112a6.814,6.814,0,0,1,.858.07c.055.01.115.187.115.287a.648.648,0,0,1-.7.654c-.263-.005-.367.087-.4.333A4.424,4.424,0,0,1-559.471,980.854Zm.316-1.118c.376.059.586-.031.592-.267a.311.311,0,0,0-.195-.229C-559.192,979.163-559,979.569-559.156,979.736Z",
    transform: "translate(581.554 -966.997)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3104",
    "data-name": "Path 3104",
    d: "M-131.324,978.748h.314l.172,1.257c.187-.267.337-.52.527-.74.174-.2.212-.595.66-.511l-1.375,1.947Z",
    transform: "translate(177.418 -966.762)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    d: "M-484.417,979.227c.371-.2.463-.737,1.033-.746-.522.591-1.157,1.047-1.15,1.888h-.37a1.8,1.8,0,0,0-.084-1.831C-484.664,978.458-484.664,978.458-484.417,979.227Z",
    transform: "translate(511.03 -966.514)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M-309.286,978.859h-.465l-.045-.079c.077-.055.152-.155.232-.159.375-.017.751-.008,1.131-.008.01.192-.062.279-.243.246-.246-.046-.341.066-.395.3-.1.448-.24.887-.365,1.335h-.3Z",
    transform: "translate(345.771 -966.637)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    d: "M-653.856,978.863h-.472c-.015-.166.013-.258.2-.253.367.011.735,0,1.1,0,.052.2-.032.277-.209.243-.267-.05-.355.089-.411.322-.106.438-.236.871-.358,1.315h-.3Z",
    transform: "translate(670.771 -966.636)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M-725.258,980.431l.509-1.837.3-.018c-.167.612-.32,1.2-.5,1.78-.022.071-.173.1-.264.152Z",
    transform: "translate(737.677 -966.604)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M-944.282,980.513c.162-.591.317-1.141.462-1.694.048-.186.142-.248.352-.167l-.509,1.847Z",
    transform: "translate(944.282 -966.643)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M-95.929,980.813l.515-1.86h.3l-.513,1.86Z",
    transform: "translate(144.03 -966.96)",
    fill: "#474747"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImps);
export default __webpack_public_path__ + "static/media/imps.97a8c46a23d32eada6dd28a2393c6ba9.svg";
export { ForwardRef as ReactComponent };